import { render, staticRenderFns } from "./TitleCollection.vue?vue&type=template&id=c0892d68&scoped=true&"
import script from "./TitleCollection.vue?vue&type=script&lang=js&"
export * from "./TitleCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0892d68",
  null
  
)

export default component.exports